import { useEffect, useState } from "react";

export default function useIsMobile() {

    const [isMobile, setIsMobile] =
        useState(window.innerWidth <= 768);

    useEffect(() => {

        const resize = () => {

            setIsMobile(
                window.innerWidth <= 768
            );

        };

        window.addEventListener(
            "resize",
            resize
        );

        return () =>

            window.removeEventListener(
                "resize",
                resize
            );

    }, []);

    return isMobile;

}